import { NotifyHelper } from "../../../helpers/toast";
import { objBoDoiCongAnDefine } from "../../action-types/bodoi-congan/IBoDoiCongAnActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const boDoiCongAnActions = {
    ...generateActions(objBoDoiCongAnDefine, "BODOI_CONGAN"),
    ...generateActionForKey(objBoDoiCongAnDefine, "BODOI_CONGAN",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objBoDoiCongAnDefine, "BODOI_CONGAN",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objBoDoiCongAnDefine, "BODOI_CONGAN",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objBoDoiCongAnDefine, "BODOI_CONGAN",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objBoDoiCongAnDefine, "BODOI_CONGAN",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
